import { css } from '@emotion/css';
import React from 'react';
import { AppIconImageContainer } from './AppIconImageContainer';

/* 2ページ目はアイコンが1行しかないので高さを確保するための要素を配置 */

export const DummyIcon: React.FC = () => (
  <div
    className={css`
      width: 33.33333%;
      height: auto;
      max-height: 40vw;
      padding: 8px 8px 29px;
      /* 画面の縦横比が小さい端末でスクロールが発生するのを抑制するために画面高さをもとに最大幅を決定します。 */
      @media (max-height: 544px) {
        .dummy {
          max-width: 14vh;
        }
      }
    `}
    aria-hidden={true}
  >
    <div className="dummy">
      <AppIconImageContainer>
        <svg width="100%" height="100%" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" />
      </AppIconImageContainer>
    </div>
  </div>
);
